import { Cache } from "memory-cache";
import moment from "moment";
// Cache
const cache = new Cache();

/* Structure error rate throttler */
export function getErrorCount() {
  let entity = cache.get("errorCount");
  let expiryTime = cache.get("errorExpiry");
  let now = moment().valueOf();
  if (entity && expiryTime && parseInt(expiryTime.toString()) > now) {
    return entity;
  } else {
    cache.put("errorCount", 100);
    cache.put("errorExpiry", now + 60000);
    return 100;
  }
}
export function updateErrorCount(count: number, resetInSeconds: number) {
  let now = moment().valueOf();
  cache.put("errorCount", count);
  cache.put("errorExpiry", now + resetInSeconds * 1000);
}

export function setErrorcount(count: number) {
  let newcount: any = cache.get("errorCount");
  //In case the cache has gone missing
  if (newcount == null) {
    cache.put("errorCount", 99);
  } else {
    newcount -= count;
    if (newcount == 0) newcount = -1;
    cache.put("errorCount", newcount);
  }
}

/* Market history throttler */

export function getMarketHistoryCount() {
  let entity = cache.get("marketCount");
  let expiryTime = cache.get("marketExpiry");
  let now = moment().valueOf();
  if (entity && expiryTime && parseInt(expiryTime.toString()) > now) {
    return entity;
  } else {
    cache.put("marketCount", 300);
    cache.put("marketExpiry", now + 60000);
    return 300;
  }
}

export function setMarketHistoryCount(count: number) {
  let newcount: any = cache.get("marketCount");
  //In case the cache has gone missing
  if (newcount == null) {
    cache.put("marketCount", 299);
  } else {
    newcount -= count;
    if (newcount == 0) newcount = -1;
    cache.put("marketCount", newcount);
  }
}
